import clsx from 'clsx';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-wjr7W",
  "hint--no-error": "pbui-lt3uO",
  "hint--has-error": "pbui-88EqZ",
  "label": "pbui-4De3l",
  "container": "pbui-BqVmN",
  "textarea": "pbui-hvsjH",
  "textarea--no-error": "pbui-gVsR6",
  "textarea--has-error": "pbui-HE-TB",
  "nothing": "pbui-GF25q",
  "textarea--focus-orange": "pbui-nZ4NU"
};
export var Hint = function Hint(_ref) {
  var children = _ref.children,
    hasError = _ref.hasError;
  var hintClasses = clsx(styles.hint, hasError ? styles['hint--has-error'] : styles['hint--no-error']);
  return /*#__PURE__*/_jsx("div", {
    className: hintClasses,
    children: children
  });
};